import { tagService } from '../_services';

const getDefaultState = () => {
  return {
    all: '',
    current: {},
    loading: {}
  }
}

export const tags = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetState ({ commit }) {
      commit('resetState')
    },
    getAllTags({ commit }) {
      commit('getAllTagsRequest');

      tagService.getAll()
      .then(
          tags => commit('getAllTagsSuccess', tags),
          error => commit('getAllTagsFailure', error)
      );
    },
    getSelectLists({ commit }) {
      commit('getDietarySelectListRequest');
      commit('getNonDietarySelectListRequest');
      tagService.getSelectList(true)
      .then(
          tags => commit('getDietarySelectListSuccess', tags),
          error => commit('getDietarySelectListFailure', error)
      );
    },
    searchTags({ commit }, payload) {
      commit('getAllTagsRequest');
      tagService.searchTags(payload)
      .then(
          tags => commit('getAllTagsSuccess', tags),
          error => commit('getAllTagsFailure', error)
      );
    },
    getById({ commit }, id) {
      commit('getByIdRequest');
      tagService.getById(id)
      .then(
        response => commit('getByIdSuccess', response),
        error => commit('getByIdFailure', error)
      );
    },
    addTag({ commit }, payload){
      commit('addTagRequest');
      tagService.addTag(payload)
      .then(
        tags => commit('addTagSuccess', tags),
        error => commit('addTagFailure', error)
      )
    },
    updateTag({ commit }, payload){
      commit('addTagRequest');
      tagService.updateTag(payload)
      .then(
        tags => commit('addTagSuccess', tags),
        error => commit('addTagFailure', error)
      )
    },
    deleteTag({ commit }, payload){
      commit('deleteTagRequest');
      tagService.deleteTag(payload)
      .then(
        commit('deleteTagSuccess'),
        error => commit('deleteTagFailure', error)
      )
      return true;
    }
  },
  mutations: {
    resetState (state) {
      Object.assign(state, getDefaultState())
    },
    getAllTagsRequest(state) {
        state.loading = 'Loading';
    },
    getAllTagsSuccess(state, tags) {
        state.all = Object.values(tags);
        state.loading = false;
    },
    getAllTagsFailure(state, error) {
        state.all = { error };
        state.loading = false;
    },
    getDietarySelectListRequest(state) {
        state.dietarySelectList = { loading: true };
    },
    getByIdRequest(state) {
      state.current = { loading: true };
    },
    getByIdSuccess(state, tag) {
      state.current = tag;
      return tag;
    },
    getByIdFailure(state, error) {
        state.current = { error };
    },
    addTagRequest(state, tag) {
      state.current = tag
    },
    addTagSuccess(state, tag) {
      if(tag.id == state.current.tag.id){
        state.current = tag;
      }
    },
    addTagFailure(state, error) {
      state.update = { error };
    },
    deleteTagRequest(state, tag) {
      state.current = tag
    },
    deleteTagSuccess(state) {
        state.current = {};
        return true;
    },
    deleteTagFailure(state, error) {
      state.update = { error };
    }
  }
}